module.exports = __webpack_public_path__ + "static/media/wheel-elipse-spin.7ac87b61.png";